/* rice-pdp.js — Organic Rice Product Detail Page */

(function () {
  'use strict';

  /* --------------------------------------------------
     Gallery
  -------------------------------------------------- */
  function initGallery() {
    const mainImg = document.querySelector('.rp-hero__main-image img');
    const thumbs = document.querySelectorAll('.rp-hero__thumb');
    const prevBtn = document.querySelector('.rp-hero__arrow--prev');
    const nextBtn = document.querySelector('.rp-hero__arrow--next');
    if (!mainImg || !thumbs.length) return;

    let current = 0;

    function goTo(idx) {
      current = (idx + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      var thumbImg = thumb.querySelector('img');
      var newSrc = thumb.dataset.fullSrc || thumbImg.src.replace('_compact', '').replace('_small', '').replace(/[?&]width=\d+/, function(m) { return m[0] + 'width=1400'; });
      var newAlt = thumb.getAttribute('aria-label') || (thumbImg && thumbImg.alt) || mainImg.alt;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion) mainImg.style.opacity = '0';
      setTimeout(function() {
        mainImg.src = newSrc;
        mainImg.srcset = '';
        mainImg.alt = newAlt;
        mainImg.style.opacity = '';
      }, reduceMotion ? 0 : 160);
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
        t.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === current);
      t.setAttribute('aria-pressed', i === current ? 'true' : 'false');
    });
  }

  /* --------------------------------------------------
     Quantity stepper
  -------------------------------------------------- */
  function initQty() {
    var input = document.querySelector('.rp-hero__qty-input');
    var dec = document.querySelector('.rp-hero__qty-btn--dec');
    var inc = document.querySelector('.rp-hero__qty-btn--inc');
    if (!input) return;

    function clamp(v) { return Math.max(1, Math.min(99, v)); }

    if (dec) dec.addEventListener('click', function () { input.value = clamp(+input.value - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = clamp(+input.value + 1); });
    input.addEventListener('change', function () { input.value = clamp(+input.value || 1); });
  }

  /* --------------------------------------------------
     Info tabs
  -------------------------------------------------- */
  function initTabs() {
    var btns = document.querySelectorAll('.rp-tabs__btn');
    var panels = document.querySelectorAll('.rp-tabs__panel');
    if (!btns.length) return;

    function activate(btn, focus) {
      btns.forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        b.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var active = panel.dataset.panel === btn.dataset.tab;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        panel.hidden = !active;
      });
      if (focus) btn.focus();
    }
    btns.forEach(function (btn, index) {
      btn.addEventListener('click', function () { activate(btn, false); });
      btn.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % btns.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + btns.length) % btns.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = btns.length - 1;
        else return;
        event.preventDefault(); activate(btns[next], true);
      });
    });
    activate(document.querySelector('.rp-tabs__btn.is-active') || btns[0], false);
  }

  /* --------------------------------------------------
     Recipe cards — inject description + meta from JSON
     Cards are rendered by Liquid; JS enriches them with
     data from red-rice-recipes.json matched by image filename.
  -------------------------------------------------- */
  function initRecipes() {
    var list = document.querySelector('.rp-recipes__list');
    var src = list && list.dataset.recipeSrc;
    if (!list || !src) return;

    fetch(src)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var recipes = Array.isArray(data) ? data : Object.values(data);
        var cards = list.querySelectorAll('.rp-recipe-card[data-image-name]');
        cards.forEach(function (card) {
          var imgName = card.dataset.imageName;
          var recipe = recipes.find(function (r) {
            return r.image && r.image.filename === imgName;
          });
          if (!recipe) return;

          var metaEl = card.querySelector('.rp-recipe-card__meta');
          if (metaEl) {
            var meta = '';
            if (recipe.totalTime) meta += recipe.totalTime;
            if (recipe.difficulty) meta += (meta ? ' · ' : '') + recipe.difficulty;
            metaEl.textContent = meta;
          }

          var descEl = card.querySelector('.rp-recipe-card__desc');
          if (descEl && recipe.description) {
            descEl.textContent = recipe.description.length > 100
              ? recipe.description.slice(0, 100) + '…'
              : recipe.description;
          }
        });
      })
      .catch(function (e) { console.warn('Rice recipe data failed to load', e); });
  }

  /* --------------------------------------------------
     Add to cart
  -------------------------------------------------- */
  function initAddToCart() {
    var btn = document.querySelector('.rp-hero__atc');
    if (!btn) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var status = document.querySelector('.rp-cart-status');
    var resetTimer;
    function announce(message, error) {
      if (!status) return;
      status.hidden = false;
      status.classList.toggle('is-error', !!error);
      status.textContent = message;
    }
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      clearTimeout(resetTimer);
      var qty = +(document.querySelector('.rp-hero__qty-input') || {}).value || 1;
      if (status) { status.hidden = true; status.textContent = ''; }
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding…';
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      })
        .then(function (response) {
          return response.json().catch(function () { return null; }).then(function (data) {
            if (!response.ok || !data || data.status >= 400 || data.errors) {
              var message = data && typeof data.description === 'string' ? data.description : 'Unable to add this item. Please try again.';
              throw new Error(message);
            }
            return data;
          });
        })
        .then(function () {
          btn.textContent = 'Added!';
          announce('Added to your cart.', false);
          resetTimer = setTimeout(function () { btn.textContent = btn.dataset.label || 'Add to Cart'; }, 1800);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function (error) {
          btn.textContent = btn.dataset.label || 'Add to Cart';
          announce(error.message && error.message !== 'Failed to fetch' ? error.message : 'Unable to connect. Please try again.', true);
        })
        .finally(function () {
          btn.disabled = false;
          btn.setAttribute('aria-busy', 'false');
          btn.classList.remove('is-loading');
        });
    });
  }

  /* --------------------------------------------------
     CTA scroll add-to-cart
  -------------------------------------------------- */
  function initCtaBtn() {
    var btn = document.querySelector('.rp-cta__btn[data-variant-id]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var hero = document.querySelector('.rp-hero__atc');
      if (hero) { hero.click(); }
    });
  }

  /* --------------------------------------------------
     Scroll entrance animations
  -------------------------------------------------- */
  /* child selectors per section for stagger */
  var STAGGER_MAP = {
    '.rp-why':     '.rp-why__benefit',
    '.rp-prepare': '.rp-prepare__step',
    '.rp-reviews': '.rp-review-card',
    '.rp-recipes': '.rp-recipe-card',
    '.rp-pantry':  '.rp-pantry-card',
  };

  function initEntranceAnimations() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.rp-why, .rp-farm, .rp-prepare, .rp-details, .rp-reviews, .rp-recipes, .rp-pantry, .rp-cta');
    if (!els.length) return;

    els.forEach(function(el) {
      el.classList.add('rp-animate');
      /* pre-mark stagger children */
      var sectionKey = Object.keys(STAGGER_MAP).find(function(k) { return el.matches(k); });
      if (sectionKey) {
        el.querySelectorAll(STAGGER_MAP[sectionKey]).forEach(function(child, i) {
          child.classList.add('rp-child-stagger');
          child.style.setProperty('--rp-stagger', (200 + i * 100) + 'ms');
        });
      }
    });

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rp-in-view');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function(el) { obs.observe(el); });
  }

  /* --------------------------------------------------
     Init
  -------------------------------------------------- */
  function initBuyNow() {
    var form = document.querySelector('.rp-hero__buy-now-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var qtyInput = document.querySelector('.rp-hero__qty-input');
      var hiddenQty = document.getElementById('rp-buy-now-qty');
      if (qtyInput && hiddenQty) hiddenQty.value = qtyInput.value || 1;
    });
  }

  function normalizeRiceCtaCopy() {
    var canonical = document.querySelector('link[rel="canonical"]');
    var path = (canonical && canonical.href ? canonical.href : window.location.href).toLowerCase();
    var title = (document.querySelector('.rp-hero__title') || {}).textContent || document.title || '';
    var isRedRice = path.indexOf('philippines-organic-red-rice') !== -1 || /red rice/i.test(title);
    if (!isRedRice) return;

    document.querySelectorAll('.rp-prepare__cta-btn').forEach(function (btn) {
      if (/add black rice to cart/i.test(btn.textContent || '')) {
        btn.textContent = 'Add Red Rice to Cart';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    normalizeRiceCtaCopy();
    initGallery();
    initQty();
    initTabs();
    initRecipes();
    initAddToCart();
    initCtaBtn();
    initEntranceAnimations();
    initBuyNow();
  });
})();
